import { runClientComponent } from '../../_common/client/client-component-runner';
import { ProductAdviceComponent } from './product-advice.component';

runClientComponent({ ProductAdviceComponent });
